import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { LocationDetailsResponse } from '../models/location-details.model';
import { LocationDetailsRepository } from '../repositories/location-details.repository';

export class GetLocationDetailsUseCase
    implements UseCase<string, LocationDetailsResponse>
{
    constructor(private readonly repository: LocationDetailsRepository) {}

    execute(id: string): Observable<LocationDetailsResponse> {
        return this.repository.getLocationDetails(id);
    }
}
